<script setup lang="ts">
  import ModalModelBellacloud from '../../components/Modais/ModalModelBellacloud.vue'
  import ModalModelParts from '../../components/Modais/ModalModelParts.vue'
  import ModalModelSlideShow from '../../components/Modais/ModalModelSlideShow.vue'
</script>

<template>
  <div class="block block--white mt-3">
    <div class="container">
      <div class="row">
        <div class="col-lg-4 order-lg-1 order-2 row-mobile">
          <h1 class="title">
            {{ name }}
          </h1>
          <h3 class="description mt-3">
            {{ description }}
          </h3>
          <p class="more ml-5 mt-4">
            {{ text }}
          </p>
          <div class="mt-5 photos-parts">
            <NavBarPartsModel
              :sessionActive="sessionArrayId"
              :parts="shoot"
              :thumb-photos="thumbPhotos"
              :translate="translate"
              :change-selected-tab="changeSelectedTab"
              @changeSession="changeSessionPhotos"
              @showModalSubscribePlans="$emit('showModalSubscribePlans', (val) => val)"
            />
          </div>
          <div class="row my-4 text-center">
            <div class="col-lg-3 col-4 mobile-section-active">
              <div v-if="sessionLabel == ''" class="text-center spin-load mt-2">
                <div class="spinner-border" role="status">
                  <span class="visually-hidden">Loading...</span>
                </div>
              </div>
              <div class="session-title" v-else>
                <div>{{ locale == 'pt-br' ? 'Parte' : 'Part' }} {{ partId + 1 }}</div>
                <div>{{ sessionLabel }}</div>
                <div class="number-image">{{ currentImage + 1 }} / {{ photos.length }}</div>
              </div>
            </div>
            <div class="col-lg-4 col-1 mobile-sections">
              <font-awesome-icon
                @click="showModalModelParts(true)"
                :icon="['fas', 'table-cells-large']"
                size="md"
                style="color: #5b5858; cursor: pointer; left: -10px"
              />
            </div>
            <div class="col-lg-3 col-3 mrg-top-2">
              <button
                type="button"
                class="btn btn-outline-dark btn-lg px-4"
                @click="showModalModelSlideShow(true)"
              >
                {{ translate.zoom }}
              </button>
            </div>
            <div class="col-lg-5 col-2 mobile-bellacloud d-flex justify-content-center">
              <button
                @click="showModalModelBellacloud(true)"
                type="button"
                class="btn btn-outline-secondary btn-lg btn-desktop"
              >
                {{ translate.saveBellaCloud }}
                <font-awesome-icon
                  :icon="['far', 'bookmark']"
                  size="md"
                  class="color-icon"
                  style="margin-left: 5px"
                />
              </button>
              <font-awesome-icon
                @click="showModalModelBellacloud(true)"
                :icon="['far', 'bookmark']"
                size="md"
                class="color-icon"
                style="cursor: pointer"
              />
            </div>
            <div class="col-lg-4 col-2 mobile-share d-flex justify-content-center">
              <button type="button" class="btn btn-outline-secondary btn-lg btn-desktop">
                {{ translate.share }}
                <font-awesome-icon
                  :icon="['fas', 'share-nodes']"
                  size="md"
                  class="color-icon"
                  style="margin-left: 5px"
                />
              </button>
              <font-awesome-icon
                :icon="['fas', 'share-nodes']"
                size="md"
                class="color-icon"
                style="cursor: pointer"
              />
            </div>
          </div>
        </div>
        <div class="col-lg-8 order-lg-2 order-1 pad-left-5">
          <CarrosselModel
            :images-model="photos"
            :name-model="name"
            :sessionLabel="sessionLabel"
            :current-image="currentImage"
            :slide-play="slidePlay"
            :seconds="secondsNormal"
            :key-down-events="keyDownEventsCarrousel"
            @showModalSubscribePlans="$emit('showModalSubscribePlans', (val) => val)"
            @changeAutomatic="changeAutomaticCarrossel"
            @updateSlidePlay="updateSlidePlay"
            @updateCurrentImage="updateCurrentImage"
            @updateSeconds="updateSeconds"
            @showModalModelSlideShow="showModalModelSlideShow"
            @updateImageView="ChangeselectBellaCloudImg"
          />
        </div>
      </div>
    </div>
  </div>
  <ModalModelSlideShow
    @showModalSubscribePlans="$emit('showModalSubscribePlans', (val) => val)"
    @showModalModelSlideShow="showModalModelSlideShow"
    @changeAutomatic="changeZoomAutomatic"
    @updateSeconds="updateSeconds"
    @changePhoto="changeNextorPrev"
    @changeSession="changeSessionPhotos"
    @updateSlidePlayZoom="updateSlidePlayZoom"
    :showSlide="showSlide"
    :imgSlide="imgSlide"
    :translate="translate"
    :key-down-events="keyDownEventsZoom"
    :total="totalPhoto - 1"
    :session="sessionArrayId"
    :loading="loadingZoom"
    :sessionLabel="sessionLabel"
    :seconds="secondsZoom"
    :partLabel="partId"
    :idxCurrent="currentImage"
    :slide-play-zoom="slidePlayZoom"
  />

  <ModalModelBellacloud
    @showModalModelBellacloud="showModalModelBellacloud"
    :showCloud="showCloud"
    :imageIdSelected="selectBellaCloudImg"
    :video="false"
  />
  <ModalModelParts
    @showModalModelParts="showModalModelParts"
    @changeSession="changeSessionPhotos"
    :showParts="showParts"
    :sessionActive="sessionArrayId"
    :change-selected-tab="changeSelectedTab"
    :parts="shoot"
    :translate="translate"
  />
</template>

<script lang="ts">
  import { isMobile } from 'views/shared/utils/mobile'
  import { dataBellacloudAlbums } from 'views/pages/data'
  import CarrosselModel from './CarrosselModel.vue'
  import NavBarPartsModel from './NavBarPartsModel.vue'
  import api from '../../api'
  import { mapState } from 'pinia'
  import { localeStore } from 'stores/locale'

  export default {
    name: 'PhotosModel',
    props: ['model', 'translate'],
    emits: ['showModalSubscribePlans', 'changeSelectdTab'],
    computed: {
      ...mapState(localeStore, ['locale'])
    },
    components: {
      CarrosselModel,
      NavBarPartsModel
    },
    created() {
      if (this.model) {
        this.getModel()
      }
    },
    watch: {
      model: function () {
        this.getModel()
      }
    },
    data() {
      return {
        name: '',
        description: '',
        text: '',
        photos: [],
        shoot: [],
        isMobile: isMobile(),
        showCloud: false,
        showImage: true,
        showParts: false,
        showSlide: false,
        albums: dataBellacloudAlbums.albums,
        imgSlide: '',
        sectionId: null,
        sessionArrayId: 0,
        partId: 0,
        zoomPhotos: [],
        totalPhoto: 0,
        sessionLabel: '',
        changeSelectedTab: 0,
        currentImage: 0,
        slidePlay: false,
        slidePlayZoom: false,
        loadingZoom: true,
        secondsNormal: 3,
        secondsZoom: 3,
        selectBellaCloudImg: 0,
        loadingChange: false,
        photosId: [],
        thumbPhotos: [[]],
        keyDownEventsCarrousel: true,
        keyDownEventsZoom: false
      }
    },
    methods: {
      getModel() {
        this.name = this.model.nameModel
        this.description = this.model.descriptionModel
        this.text = this.model.text
        this.photos = this.model.shoot[0].sessions[0].photos
        this.sessionLabel = this.model.shoot[0].sessions[0].name
        this.sectionId = this.model.shoot[0].sessions[0].sectionId
        this.shoot = this.model.shoot
        this.loadingZoom = false
        this.shoot = this.model.shoot
        this.selectBellaCloudImg = this.model.shoot[0].sessions[0].photosId[0]
        this.thumbPhotos = this.model.firstPhotoSection
      },
      showModalModelBellacloud(value) {
        if (value) {
          this.keyDownEventsCarrousel = false
        } else {
          this.keyDownEventsCarrousel = true
        }
        this.showCloud = value
      },
      showModalModelParts(value) {
        this.showParts = value
      },
      async showModalModelSlideShow(value) {
        this.showSlide = value
        this.imgSlide = ''
        if (value) {
          this.keyDownEventsCarrousel = false
          this.keyDownEventsZoom = true
          if (this.slidePlay) {
            this.slidePlay = false
            this.slidePlayZoom = true
          }
          this.loadingZoom = true
          let body = document.getElementsByTagName('body')
          body[0].style.overflowY = 'hidden'
          this.zoomPhotos = await this.getPhostosMaskZoom(this.sectionId, this.shoot[this.partId].sessions[this.sessionArrayId].photosId[this.currentImage])
          this.totalPhoto = this.shoot[this.partId].sessions[this.sessionArrayId].photosId.length
          this.imgSlide = this.zoomPhotos[0]
          this.loadingZoom = false
        } else {
          this.keyDownEventsCarrousel = true
          this.keyDownEventsZoom = false
          let body = document.getElementsByTagName('body')
          body[0].style.overflowY = 'auto'
          if (this.slidePlayZoom) {
            this.slidePlay = true
            this.slidePlayZoom = false
          }
        }
      },
      async changeNextorPrev(change = 0) {
        this.loadingZoom = true
        this.zoomPhotos = await this.getPhostosMaskZoom(this.sectionId, this.shoot[this.partId].sessions[this.sessionArrayId].photosId[change])
        this.imgSlide = this.zoomPhotos[0]
        this.currentImage = change
        this.loadingZoom = false
      },
      async changeSessionPhotos({ part, session, next = true, zoom = null }) {
        this.photos = []
        this.sessionLabel = ''
        this.sessionArrayId = session
        if (this.shoot[part].sessions[session].photos && zoom == null)
          this.photos = this.shoot[part].sessions[session].photos
        else this.photos = await this.getPhostosMask(this.shoot[part].sessions[session].sectionId)

        this.sectionId = this.shoot[part].sessions[session].sectionId
        this.partId = part
        this.sessionLabel = this.shoot[part].sessions[session].name
        this.changeSelectedTab = this.partId
        this.currentImage = next ? 0 : this.photos.length - 1
        //Quando fechar o zoom, carregar o index da imagem que estava
        if (zoom != null) {
          this.currentImage = zoom
        }
      },

      async changeZoomAutomatic(next = true) {
        var session = 0
        if (this.showSlide) {
          if (next) {
            if (this.shoot[this.partId].sessions.length > this.sessionArrayId + 1) {
              //Avança Seção
              this.loadingZoom = true
              session = this.sessionArrayId + 1
            } else if (
              this.shoot[this.partId].sessions.length - this.sessionArrayId == 1 &&
              this.shoot.length > this.partId + 1
            ) {
              //Avança Parte
              this.loadingZoom = true
              session = 0
              this.partId = this.partId + 1
              this.changeSelectedTab = this.partId
            } else if (this.shoot.length == this.partId + 1) {
              //Final do ensaio
              this.slidePlayZoom = false
              return false
            }
            this.loadingZoom = true
            this.currentImage = 0
            this.zoomPhotos = await this.getPhostosMaskZoom(
              this.shoot[this.partId].sessions[session].sectionId,
              this.shoot[this.partId].sessions[session].photosId[this.currentImage]
            )
            this.imgSlide = this.zoomPhotos[0]
            this.totalPhoto = this.shoot[this.partId].sessions[session].photosId.length
            this.sessionArrayId = session
            this.sectionId = this.shoot[this.partId].sessions[session].sectionId
            this.sessionLabel = this.shoot[this.partId].sessions[session].name
            this.loadingZoom = false
          } else {
            if (this.sessionArrayId > 0) {
              //Retrocede Seção
              this.loadingZoom = true
              session = this.sessionArrayId - 1
            } else if (this.sessionArrayId == 0 && this.partId > 0) {
              //Retrocede Parte
              this.loadingZoom = true
              this.partId = this.partId - 1
              session = this.shoot[this.partId].sessions.length - 1
              this.changeSelectedTab = this.partId
            } else if (this.sessionArrayId == 0 && this.partId == 0) {
              //Final do ensaio
              return false
            }
            let ultimoIndice = this.shoot[this.partId].sessions[session].photosId.length
            this.loadingZoom = true
            this.zoomPhotos = await this.getPhostosMaskZoom(
              this.shoot[this.partId].sessions[session].sectionId,
              this.shoot[this.partId].sessions[session].photosId[ultimoIndice - 1]
            )
            this.imgSlide = this.zoomPhotos[0]
            this.totalPhoto = this.shoot[this.partId].sessions[session].photosId.length
            this.sessionArrayId = session
            this.sectionId = this.shoot[this.partId].sessions[session].sectionId
            this.sessionLabel = this.shoot[this.partId].sessions[session].name
            this.currentImage = ultimoIndice - 1
            this.loadingZoom = false
          }
        }
      },
      async changeAutomaticCarrossel(next = true) {
        if (next) {
          if (this.shoot[this.partId].sessions.length > this.sessionArrayId + 1) {
            //Avança Seção
            this.changeSessionPhotos({
              part: this.partId,
              session: ++this.sessionArrayId,
              next: true
            })
          } else if (
            this.shoot[this.partId].sessions.length - this.sessionArrayId == 1 &&
            this.shoot.length > this.partId + 1
          ) {
            //Avança Parte
            this.sessionArrayId = 9999
            this.changeSessionPhotos({
              part: ++this.partId,
              session: 0,
              next: true
            })
            this.changeSelectedTab = this.partId
          } else if (this.shoot.length == this.partId + 1) {
            //fim do ensaio
            this.slidePlay = false
          }
        } else {
          if (this.sessionArrayId > 0) {
            //Retrocede Seção
            this.changeSessionPhotos({
              part: this.partId,
              session: --this.sessionArrayId,
              next: false
            })
          } else if (this.sessionArrayId == 0 && this.partId > 0) {
            //Retrocede Parte
            this.sessionArrayId = 9999
            this.changeSessionPhotos({
              part: --this.partId,
              session: this.shoot[this.partId].sessions.length - 1,
              next: false
            })
            this.changeSelectedTab = this.partId
          }
        }
      },
      async getPhostosMask(id, zoom = 0) {
        return api
          .get('v1/modelos/fernanda-campos/section/' + id + '?grande=' + zoom)
          .then(({ data }) => {
            this.photosId = data.photosId
            return data.photos
          })
      },
      async getPhostosMaskZoom(id, photoId) {
        return api
          .get('v1/modelos/fernanda-campos/section/' + id + `/photo/${photoId}` + '?grande=1')
          .then(({ data }) => {
            this.photosId = data.photosId
            return data.photos
          })
      },
      updateSlidePlay(value) {
        this.slidePlay = value
      },
      updateSlidePlayZoom(value) {
        this.slidePlayZoom = value
      },
      updateCurrentImage(value) {
        this.currentImage = value
      },
      updateSeconds(value) {
        this.secondsNormal = value
        this.secondsZoom = value
      },
      async ChangeselectBellaCloudImg(val) {
        if (this.model?.shoot[this.partId]?.sessions[this.sessionArrayId]?.photosId)
          this.selectBellaCloudImg =
            this.model?.shoot[this.partId]?.sessions[this.sessionArrayId]?.photosId[val - 1] ?? 1
        else if (this.photosId.length) this.selectBellaCloudImg = this.photosId[val - 1]
      }
    }
  }
</script>

<style scoped lang="css">
  .block {
    padding: 25px 0;
  }

  .title {
    color: #000000;
    font-family: 'Bebas-Neue';
    font-size: 72px;
    font-weight: bold;
    letter-spacing: 0;
    line-height: 72px;
    text-transform: uppercase;
    margin-top: 2px;
  }

  .description {
    color: #b20000;
    font-family: 'Roboto-Medium';
    font-size: 24px;
    font-weight: 500;
    letter-spacing: 0;
    line-height: 28px;
  }

  .more {
    color: #5b5858;
    font-family: 'Roboto-Regular';
    font-size: 16px;
    letter-spacing: 0;
    line-height: 19px;
  }

  .btn-outline-dark {
    font-family: 'Exo-2';
    font-size: 14px;
    letter-spacing: 0;
    text-align: center;
    box-sizing: border-box;
    height: 40px;
    width: 84px;
    border: 1px solid #5b5858;
    border-radius: 25px;
  }

  .btn-outline-secondary {
    font-family: 'Exo-2';
    font-size: 14px;
    letter-spacing: 0;
    border-radius: 25px;
    border: none;
  }

  .btn-outline-secondary:hover {
    background-color: #f2f2f2;
    color: #5b5858;
  }

  .mobile-section-active,
  .mobile-sections,
  .btn-mobile {
    color: #444444;
    font-size: 14px;
    display: none;
  }

  .mobile-sections,
  .mobile-share,
  .mobile-bellacloud {
    float: right;
  }

  .mobile-bellacloud > .fa-bookmark {
    display: none;
  }

  .mobile-share > .fa-share-nodes {
    display: none;
  }

  .pad-left-5 {
    padding-left: 3rem !important;
  }

  .mrg-top-2 {
    margin-top: 0.5rem !important;
  }

  .number-image {
    display: none;
  }

  .color-icon {
    color: #5b5858;
  }

  @media (min-width: 769px) {
    .text {
      display: block;
      color: #fff;
      max-width: 350px;
    }
  }

  /* regras mobile 992vp */
  @media screen and (max-width: 992px) {
    .block {
      padding: 0px 0;
      margin-top: 0 !important;
    }

    .title,
    .description,
    .more,
    .photos-parts,
    .btn-desktop {
      display: none;
    }

    .btn-outline-dark {
      padding-right: 15px !important;
      padding-left: 15px !important;
      font-size: 14px;
      width: unset;
    }

    .mobile-section-active,
    .mobile-sections {
      display: block;
    }

    .mobile-bellacloud > .fa-bookmark {
      display: block;
    }

    .mobile-share > .fa-share-nodes {
      display: block;
      float: center;
    }

    .container {
      padding: 0px 0px;
    }

    .pad-left-5 {
      padding-left: 0rem !important;
    }

    .mrg-top-2 {
      margin-top: -10px !important;
    }

    .mobile-section-active {
      top: -18px;
    }

    .session-title {
      font-family: 'Roboto-Regular';
      font-size: 13px;
    }

    .fa-table-cells-large {
      top: -3px;
    }

    .row-mobile {
      height: 120px;
    }

    .number-image {
      display: block;
    }

    .color-icon {
      color: #5b5858;
    }
  }
</style>
